import Vue from 'vue'
import Set from '../models/set'
import ApiBase from '@/api/apiBase'

class ApiSets {

    static update(sets, tournamentID, callBack, errorCallBack) {
        
        ApiBase.put(`/tournaments/${tournamentID}`, sets, callBack, ApiBase.noParse, errorCallBack)
    }

}

export default ApiSets


// WEBPACK FOOTER //
// ./src/api/apiSets.js